export type FunnelStage =
  | "onboarding"
  | "campaign_creation"
  | "activation"
  | "billing";

export type ScreenKey =
  | "welcome"
  | "verify_email"
  | "upgrade_modal"
  | "checkout"
  | "campaign_new"
  | "campaign_details_step"
  | "campaign_offer_step"
  | "campaign_collaboration_type_step"
  | "campaign_deliverables_step"
  | "home"
  | "creator_invite";

type ScreenDefinition = {
  pageName: string;
  funnelStage: FunnelStage;
};

export const SCREEN_CATALOG: Record<ScreenKey, ScreenDefinition> = {
  welcome: { pageName: "welcome", funnelStage: "onboarding" },
  verify_email: { pageName: "verify_email", funnelStage: "onboarding" },
  upgrade_modal: { pageName: "upgrade_modal", funnelStage: "billing" },
  checkout: { pageName: "checkout", funnelStage: "billing" },
  campaign_new: { pageName: "campaign_new", funnelStage: "campaign_creation" },
  campaign_details_step: {
    pageName: "campaign_details_step",
    funnelStage: "campaign_creation",
  },
  campaign_offer_step: {
    pageName: "campaign_offer_step",
    funnelStage: "campaign_creation",
  },
  campaign_collaboration_type_step: {
    pageName: "campaign_collaboration_type_step",
    funnelStage: "campaign_creation",
  },
  campaign_deliverables_step: {
    pageName: "campaign_deliverables_step",
    funnelStage: "campaign_creation",
  },
  home: { pageName: "home", funnelStage: "activation" },
  creator_invite: { pageName: "creator_invite", funnelStage: "activation" },
};
